module.exports = __webpack_public_path__ + "img/TNC.a6150971.svg";